module.exports = __webpack_public_path__ + "img/des.afb590f5.svg";